// Use the same saved millimetre totals as the table viewer and work summary.
export function sizeListKantRows(tables) {
  const totals = new Map();
  for (const table of tables) {
    for (const entry of String(table.kantLength ?? table.kant_length ?? "").split("|")) {
      const [rawType, rawLength] = entry.split(":");
      const type = rawType.trim();
      const length = Number(rawLength);
      if (Number.isFinite(length) && length > 0) {
        totals.set(type, (totals.get(type) ?? 0) + length);
      }
    }
  }
  const types = [["04", "0,4 S"], ["2", "2 G"], ["42", "42 LAT"], ["1", "1L"]];
  const rows = types.filter(([type]) => totals.has(type)).map(([type, label]) => [
    label, `${Math.round(totals.get(type) / 1000)} m`
  ]);
  return rows.length ? rows : [["Nincs kant", "0 m"]];
}
